import { Controller } from 'stimulus'

/**
 * Manages js for the down payment step (StimulusJS Controller)
 *
 * @class DownPaymentController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = [
    'error',
    'slider',
    'sourceSelect',
  ]

  disabledSelectCss = 'form__select--disabled'

  /**
   * @function Controllers.DownPaymentController.watchSlider
   * @memberof Controllers
   * @description Keeps tabs on the slider to know when it goes to zero. If it
   * does the dropdown becomes disabled.
   *
   * @return {undefined} Manipulates the DOM.
   */
  watchSlider() {
    if (this.sliderTarget.value === '0') {
      this._hideErrorState()
      this._disableSourceSelect()
    } else {
      if (this.hasErrorTarget) {
        this.errorTarget.classList.add('form__errors-list--hidden')
      }
      this._showErrorState()
      this._enableSourceSelect()
    }
  }


  // Private


  /**
   * @function Controllers.DownPaymentController._showErrorState
   * @memberof Controllers
   * @description Shows the error state if it exists
   * @private
   *
   * @return {undefined} Manipulates the DOM.
   */
  _showErrorState() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove('form__errors-list--hidden')
    }
  }

  /**
   * @function Controllers.DownPaymentController._hideErrorState
   * @memberof Controllers
   * @description Hides the error state if it exists
   * @private
   *
   * @return {undefined} Manipulates the DOM.
   */
  _hideErrorState() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('form__errors-list--hidden')
    }
  }

  /**
   * @function Controllers.DownPaymentController._disableSourceSelect
   * @memberof Controllers
   * @description Disables the select and affects styling
   * @private
   *
   * @return {undefined} Manipulates the DOM.
   */
  _disableSourceSelect() {
    this.sourceSelectTarget.disabled = true
    this.sourceSelectTarget.classList.add(this.disabledSelectCss)
  }

  /**
   * @function Controllers.DownPaymentController._enableSourceSelect
   * @memberof Controllers
   * @description Enables the select and affects styling
   * @private
   *
   * @return {undefined} Manipulates the DOM.
   */
  _enableSourceSelect() {
    this.sourceSelectTarget.disabled = false
    this.sourceSelectTarget.classList.remove(this.disabledSelectCss)
  }
}
